// extracted by mini-css-extract-plugin
export default {"pageWrapper":"pageWrapper__eY1yE","title":"title__c8-7I","overlay":"overlay__+Q29U","overlayInner":"overlayInner__Jukfl","innerTitle":"innerTitle__xRLls","moiBtn":"moiBtn__U-WuU"};